"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.EventServiceApiSdk = void 0;
var EventServiceApiSdk = /** @class */ (function () {
    function EventServiceApiSdk(caller, serverLookup, servers) {
        if (servers === void 0) { servers = [{ url: 'https://api.{environment}.klouds.io/{basePath}', variables: { environment: 'dev', basePath: 'events' } }, { url: 'https://api.klouds.io/{basePath}', variables: { environment: 'prod', basePath: 'events' } }, { url: 'http://localhost:{port}', variables: { environment: 'local', port: '3012' } }]; }
        this.caller = caller;
        this.serverLookup = serverLookup;
        this.servers = servers;
    }
    EventServiceApiSdk.prototype.server = function () {
        var _this = this;
        if (this.servers.length === 0)
            return undefined;
        var server = !this.serverLookup ? this.servers[0] : this.servers.find(function (it) { return Object.keys(_this.serverLookup).reduce(function (result, key) { return result && (!_this.serverLookup[key] || it.variables[key] === _this.serverLookup[key]); }, true); });
        return server && Object.keys(server).filter(function (it) { return it !== 'url'; }).reduce(function (url, key) { return url.replace("{" + key + "}", server.variables[key]); }, server.url);
    };
    EventServiceApiSdk.prototype.getEvents = function (queryParameters, multiQueryParameters, headers) {
        if (headers === void 0) { headers = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var resource, path, versionedHeaders, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resource = '/event';
                        path = "/event";
                        versionedHeaders = headers;
                        return [4 /*yield*/, this.caller.call('GET', resource, path, undefined, {}, queryParameters, multiQueryParameters, versionedHeaders, this.server())];
                    case 1:
                        result = _a.sent();
                        if (result.statusCode === 200) {
                            return [2 /*return*/, { statusCode: 200, headers: result.headers, result: JSON.parse(result.body) }];
                        }
                        throw new Error("Unknown status " + result.statusCode + " returned from " + path);
                }
            });
        });
    };
    EventServiceApiSdk.prototype.createEvent = function (body, headers) {
        if (headers === void 0) { headers = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var resource, path, versionedHeaders, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resource = '/event';
                        path = "/event";
                        versionedHeaders = headers;
                        return [4 /*yield*/, this.caller.call('POST', resource, path, JSON.stringify(body), {}, {}, {}, versionedHeaders, this.server())];
                    case 1:
                        result = _a.sent();
                        if (result.statusCode === 202) {
                            return [2 /*return*/, { statusCode: 202, headers: result.headers, result: result.body }];
                        }
                        throw new Error("Unknown status " + result.statusCode + " returned from " + path);
                }
            });
        });
    };
    EventServiceApiSdk.prototype.getView = function (params, headers) {
        if (headers === void 0) { headers = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var resource, path, versionedHeaders, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resource = '/event/{eventId}';
                        path = "/event/" + params.eventId;
                        versionedHeaders = headers;
                        return [4 /*yield*/, this.caller.call('GET', resource, path, undefined, params, {}, {}, versionedHeaders, this.server())];
                    case 1:
                        result = _a.sent();
                        if (result.statusCode === 200) {
                            return [2 /*return*/, { statusCode: 200, headers: result.headers, result: JSON.parse(result.body) }];
                        }
                        throw new Error("Unknown status " + result.statusCode + " returned from " + path);
                }
            });
        });
    };
    EventServiceApiSdk.prototype.deleteEvent = function (params, headers) {
        if (headers === void 0) { headers = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var resource, path, versionedHeaders, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resource = '/event/{eventId}';
                        path = "/event/" + params.eventId;
                        versionedHeaders = headers;
                        return [4 /*yield*/, this.caller.call('DELETE', resource, path, undefined, params, {}, {}, versionedHeaders, this.server())];
                    case 1:
                        result = _a.sent();
                        if (result.statusCode === 200) {
                            return [2 /*return*/, { statusCode: 200, headers: result.headers, result: result.body }];
                        }
                        throw new Error("Unknown status " + result.statusCode + " returned from " + path);
                }
            });
        });
    };
    EventServiceApiSdk.prototype.getSchema = function (headers) {
        if (headers === void 0) { headers = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var resource, path, versionedHeaders, result;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        resource = '/schema';
                        path = "/schema";
                        versionedHeaders = headers;
                        return [4 /*yield*/, this.caller.call('GET', resource, path, undefined, {}, {}, {}, versionedHeaders, this.server())];
                    case 1:
                        result = _a.sent();
                        if (result.statusCode === 200) {
                            return [2 /*return*/, { statusCode: 200, headers: result.headers, result: JSON.parse(result.body) }];
                        }
                        throw new Error("Unknown status " + result.statusCode + " returned from " + path);
                }
            });
        });
    };
    return EventServiceApiSdk;
}());
exports.EventServiceApiSdk = EventServiceApiSdk;
__exportStar(require("./model"), exports);
//# sourceMappingURL=sdk.js.map